import React from 'react';
import { TrendingUp, Users } from 'lucide-react';
export function ScarcityIndicator() {
  return <div className="w-full max-w-md mx-auto mb-6" data-id="element-61">
      <div className="flex justify-between items-end mb-2" data-id="element-62">
        <div className="flex items-center gap-2 text-red-600 font-bold text-sm animate-pulse" data-id="element-63">
          <TrendingUp className="w-4 h-4" data-id="element-64" />
          <span data-id="element-65">¡Casi agotado!</span>
        </div>
        <div className="text-xs text-gray-500 font-medium" data-id="element-66">
          <span className="text-gray-900 font-bold" data-id="element-67">87%</span> de cupos vendidos
        </div>
      </div>

      <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden border border-gray-200" data-id="element-68">
        <div className="h-full bg-gradient-to-r from-red-500 via-orange-500 to-yellow-500 rounded-full relative" style={{
        width: '87%'
      }} data-id="element-69">
          <div className="absolute top-0 left-0 w-full h-full bg-white opacity-20 animate-[shimmer_2s_infinite]" data-id="element-70"></div>
        </div>
      </div>

      <div className="mt-2 flex items-center justify-center gap-2 text-xs text-gray-600 bg-yellow-50 py-1 px-3 rounded-full border border-yellow-100 w-fit mx-auto" data-id="element-71">
        <Users className="w-3 h-3 text-yellow-600" data-id="element-72" />
        <span data-id="element-73">
          Solo quedan <span className="font-bold text-red-600" data-id="element-74">23 cupos</span>{' '}
          con este descuento
        </span>
      </div>
    </div>;
}